module.exports = __webpack_public_path__ + "static/game.1ca48bfa.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/game.png
// module id = 1495
// module chunks = 19843951674672